import React from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";
import 'styles/pages/RouterErrorPage.css';

const RouterErrorPage = React.memo(() => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: 'relative',
        height: '100vh',
        width: '100vw',
        maxHeight: '100vh',
        maxWidth: '100vw',
        background: 'linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%)',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: { xs: 1, sm: 2, md: 3 },
        px: { xs: 1, sm: 2, md: 3 },
        boxSizing: 'border-box',
      }}
    >
      <Box
        component="img"
        src={first}
        alt="first_image"
        title="first image icon"
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: { xs: '80px', sm: '120px', md: '150px', lg: '180px' },
          height: 'auto',
          maxHeight: '20vh',
          opacity: 0.6,
          zIndex: 0,
          display: { xs: 'none', md: 'block' },
        }}
      />
      <Box
        component="img"
        src={second}
        alt="second_image"
        title="second image icon"
        sx={{
          position: 'absolute',
          top: { xs: '15vh', sm: '20vh', md: '25vh' },
          right: 0,
          width: { xs: '70px', sm: '100px', md: '130px', lg: '160px' },
          height: 'auto',
          maxHeight: '15vh',
          opacity: 0.5,
          zIndex: 0,
          display: { xs: 'none', md: 'block' },
        }}
      />

      <Box
        component="img"
        src={four}
        alt="four_image"
        title="four image icon"
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: { xs: '80px', sm: '120px', md: '150px', lg: '180px' },
          height: 'auto',
          maxHeight: '20vh',
          opacity: 0.6,
          zIndex: 0,
          display: { xs: 'none', md: 'block' },
        }}
      />
      <Box
        component="img"
        src={five}
        alt="five_image"
        title="five image icon"
        sx={{
          position: 'absolute',
          bottom: { xs: '10vh', sm: '15vh', md: '20vh' },
          left: 0,
          width: { xs: '70px', sm: '100px', md: '130px', lg: '160px' },
          height: 'auto',
          maxHeight: '15vh',
          opacity: 0.5,
          zIndex: 0,
          display: { xs: 'none', md: 'block' },
        }}
      />

      {/* Main Content */}
      <Container
        maxWidth="md"
        sx={{
          position: 'relative',
          zIndex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: { xs: '0.5vh', sm: '0.8vh', md: '1vh' },
          py: { xs: 1, sm: 2 },
          boxSizing: 'border-box',
        }}
      >
        {/* Center Illustration */}
        <Box
          component="img"
          src="https://bxidevelopment1.s3.ap-south-1.amazonaws.com/category/Assets/Group+1000003294.svg"
          alt="three_image"
          title="three image icon"
          sx={{
            width: { xs: 'clamp(180px, 35vw, 280px)', sm: 'clamp(240px, 40vw, 350px)', md: 'clamp(300px, 45vw, 400px)' },
            maxWidth: '90vw',
            height: 'auto',
            maxHeight: { xs: '30vh', sm: '35vh', md: '40vh' },
            mb: { xs: '1vh', sm: '1.5vh', md: '2vh' },
            mx: 'auto',
            objectFit: 'contain',
          }}
        />

        {/* 404 Heading */}
        <Typography
          sx={{
            color: "#226192",
            fontFamily: "Poppins",
            fontWeight: 700,
            fontSize: { xs: 'clamp(20px, 4.5vw, 26px)', sm: 'clamp(28px, 5vw, 34px)', md: 'clamp(32px, 5.5vw, 40px)' },
            textAlign: "center",
            mb: { xs: '0.8vh', sm: '1vh', md: '1.2vh' },
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
          }}
        >
          404! Page Not Found
        </Typography>

        {/* Description Text */}
        <Box
          sx={{
            mb: { xs: '0.8vh', sm: '1vh', md: '1.2vh' },
            maxWidth: { xs: '90vw', sm: '80vw', md: '600px' },
            mx: 'auto',
          }}
        >
          <Typography
            sx={{
              color: "#272523B2",
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: { xs: 'clamp(12px, 2.8vw, 14px)', sm: 'clamp(14px, 3vw, 16px)', md: 'clamp(16px, 3.2vw, 18px)' },
              textAlign: "center",
              mb: { xs: '0.6vh', sm: '0.8vh', md: '1vh' },
              lineHeight: 1.5,
            }}
          >
            Don't worry, we will fix it.
          </Typography>

          <Typography
            sx={{
              color: "#272523B2",
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: { xs: 'clamp(12px, 2.8vw, 14px)', sm: 'clamp(14px, 3vw, 16px)', md: 'clamp(16px, 3.2vw, 18px)' },
              textAlign: "center",
              lineHeight: 1.5,
            }}
          >
            We are working to build something exiting! please try again after
            sometime.
          </Typography>
        </Box>

        {/* Back Button */}
        <Button
          variant="contained"
          onClick={() => {
            navigate(-1);
          }}
          sx={{
            ...btn,
            mt: { xs: '1vh', sm: '1.5vh', md: '2vh' },
            mx: 'auto',
          }}
        >
          <Box component="img" src={BackToHomeIcon} />
          Back to home
        </Button>
      </Container>
    </Box>
  );
});

export default RouterErrorPage;

const btn = {
  display: "flex",
  gap: "8px",
  alignItems: "center",
  justifyContent: "center",
  minWidth: { xs: 'clamp(160px, 35vw, 180px)', sm: 'clamp(180px, 38vw, 200px)' },
  height: { xs: 'clamp(40px, 5.5vh, 44px)', sm: 'clamp(44px, 6vh, 48px)' },
  maxHeight: { xs: '6vh', sm: '7vh' },
  borderRadius: 2,
  background: "#226192",
  color: "#fff",
  fontFamily: "Poppins",
  fontSize: { xs: 'clamp(13px, 2.5vw, 14px)', sm: 'clamp(14px, 2.8vw, 16px)' },
  fontWeight: 600,
  textTransform: "none",
  boxShadow: '0 4px 12px rgba(34, 97, 162, 0.3)',
  transition: 'all 0.3s ease',
  "&:hover": {
    background: "#1a4d7c",
    boxShadow: '0 6px 16px rgba(34, 97, 162, 0.4)',
    transform: 'translateY(-2px)',
  },
  "& img": {
    width: { xs: 'clamp(16px, 3vw, 18px)', sm: '18px' },
    height: { xs: 'clamp(16px, 3vw, 18px)', sm: '18px' },
  },
};




const BackToHomeIcon = "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Images/CommonImages/BackToHomeIcon.svg";
const first = "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/animation_lo2s0oze 1.svg";
const second = "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/animation_lo2s0oze 2.svg";
const four = "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Vector.svg";
const five = "https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Vector (1).svg";
